import { afterNextRender, ChangeDetectorRef, Component } from "@angular/core";
import { Headers, Http } from "@angular/http";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { ToastyService } from "ng2-toasty";
import { ReCaptchaV3Service } from "ngx-captcha";
import { environment } from "../../../environments/environment";
import { ErrorHandlerService } from "../../core/error-handler.service";
import { DoisFatoresResponse, EsqueciSenha } from "../../core/model";
import { AuthService } from "../auth.service";


@Component({
  standalone: false,
  selector: "app-login-form",
  templateUrl: "./login-form.component.html",
  styleUrls: ["./login-form.component.css"]
})
export class LoginFormComponent {
  esqueciSenha = new EsqueciSenha();
  usuarioUrl;
  confirmeSenha;
  reCaptcha;
  documentRecaptcha;
  loading = true;
  exibirLoadingLogin = true;
  logo = environment.logo
  email: string;
  senha: string;

  umMinutoStarter;

  timerAtivo: boolean = false;
  tempoRestante: number = 0;

  constructor(
    private http: Http,
    public auth: AuthService,
    private errorHandler: ErrorHandlerService,
    private router: Router,
    private title: Title,
    private toasty: ToastyService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private cdr: ChangeDetectorRef
  ) {
    this.title.setTitle("Login");
    this.usuarioUrl = `${environment.apiUrl}/usuarios`;

    afterNextRender(() => this.inicializarRecaptcha());
  }

  private inicializarRecaptcha() {
    this.reCaptchaV3Service.execute(
      "6LdCbIoUAAAAAJL-BVvqkCR5fhjEg84kUXNS2MOr",
      "login",
      token => {
        this.reCaptcha = token;
        this.documentRecaptcha = document.getElementsByClassName(
          "grecaptcha-badge"
        );
        this.openLoginView();
        this.atualizarLoadingLogin(false);
      }
    );
  }

  login(usuario: string, senha: string) {
    this.openLogin = false;
    this.atualizarLoadingLogin(true);
    usuario = usuario.toLowerCase();
    if (this.reCaptcha != null) {
      this.auth
        .login(usuario, senha)
        .then(() => {
          this.documentRecaptcha[0].style.display = "none";
          this.router.navigate(["/home"]);
          sessionStorage.setItem("urlLogin", "/login");
          // A senha em claro nao fica mais guardada no navegador. Ela era gravada aqui para
          // que a home pudesse medir o comprimento dela e, depois, reenvia-la como
          // "senha_antiga". Agora quem diz que a troca e obrigatoria e o claim
          // `deve_trocar_senha` do proprio token, e a senha atual e digitada na hora.
          this.openLogin = true;
          this.atualizarLoadingLogin(false);
        })
        .catch(erro => {
          this.openLogin = true;
          this.atualizarLoadingLogin(false);
          this.errorHandler.handle(erro);
        });
    } else {
      this.openLogin = true;
      this.atualizarLoadingLogin(false);
      this.errorHandler.handle("É necessário a confirmação do CAPCTHA.");
    }
  }

  onLoginEnter(usuario: HTMLInputElement, senha: HTMLInputElement) {
    if (!usuario.value || !senha.value) {
      return;
    }
    this.exibirDialogoVerificacao(usuario.value, senha.value);
    senha.value = '';
  }

  openLogin;
  openForgotPass;
  openToken;
  openNewPass: boolean;
  
  displayVerificationDialog: boolean = false;
  codigoVerificacao: string = '';
  codigoInvalido: boolean = false;

  displayEscolhaTokenDialog: boolean = false;
  dataUltimoToken: string = null;
  usandoUltimoCodigo: boolean = false;

  private atualizarLoadingLogin(valor: boolean): void {
    this.loading = valor;
    this.exibirLoadingLogin = valor;
    this.cdr.detectChanges();
  }

  async verificarDoisFatores(email: string, senha: string): Promise<DoisFatoresResponse> {
    return await this.validarDoisFatores({
      email: email,
      senha: senha,
      token: this.codigoVerificacao
    })
    .catch(erro => {
      this.errorHandler.handle(erro);
      return null;
    });
  }

 async exibirDialogoVerificacao(email: string, senha: string) {
    let resposta: DoisFatoresResponse = await this.verificarDoisFatores(email, senha);
    if(environment.production === false || !resposta || !resposta.doisFatores){
      this.login(email, senha);
      return;
    }
    this.email = email;
    this.senha = senha;
    this.codigoVerificacao = '';
    this.codigoInvalido = false;
    this.dataUltimoToken = resposta.dataToken;

    if (this.dataUltimoToken) {
      // já existe um código gerado anteriormente: pergunta se quer um novo ou usar o último
      this.displayEscolhaTokenDialog = true;
    } else {
      // nunca foi gerado um código para este usuário: segue a rotina normal
      this.gerarNovoCodigo();
    }
  }

  gerarNovoCodigo() {
    this.usandoUltimoCodigo = false;
    this.dataUltimoToken = null;
    this.displayEscolhaTokenDialog = false;
    this.displayVerificationDialog = true;

    this.solicitarLogin({
      email: this.email,
      senha: this.senha,
      token: this.codigoVerificacao
    })
    .then(() => {
      this.iniciarTimer();
    })
    .catch(erro => this.errorHandler.handle(erro));
  }

  usarUltimoCodigo() {
    this.usandoUltimoCodigo = true;
    this.displayEscolhaTokenDialog = false;
    this.displayVerificationDialog = true;
  }

  reenviarCodigo() {
    this.usandoUltimoCodigo = false;
    this.dataUltimoToken = null;
     this.solicitarLogin({
      email: this.email,
      senha: this.senha,
      token: this.codigoVerificacao
    })
    .then(() => {
      this.iniciarTimer();
    })
    .catch(erro => this.errorHandler.handle(erro));
}

  fecharDialogoVerificacao() {
    this.displayVerificationDialog = false;
    this.displayEscolhaTokenDialog = false;
    this.codigoVerificacao = '';
    this.codigoInvalido = false;
    this.usandoUltimoCodigo = false;
    this.dataUltimoToken = null;
  }

  iniciarTimer() {
    this.tempoRestante = 40;
    this.timerAtivo = true;
    this.cdr.detectChanges();

    const timer = setInterval(() => {
      this.tempoRestante--;
      if (this.tempoRestante === 0) {
        this.timerAtivo = false;
        clearInterval(timer);
      }
      this.cdr.detectChanges();
    }, 1000);
  }
  
  verificarCodigo() {
    if (!this.codigoVerificacao || this.codigoVerificacao.length < 6) {
      this.codigoInvalido = true;
      return;
    }else{
      this.codigoInvalido = false;
    }
    
    this.validarCodigoVerificacao({
      email: this.email,
      senha: this.senha,
      token: this.codigoVerificacao
    })
    .then(retorno => {
      if (retorno) {
        this.fecharDialogoVerificacao();
         this.login(this.email, this.senha);
      } else {
        this.codigoInvalido = true;
      }
    })
    .catch(erro => this.errorHandler.handle(erro));
  }
  
  openLoginView() {
    this.openLogin = true;
    this.openForgotPass = false;
    this.openToken = false;
    this.openNewPass = false;
  }
  openForgotPassVIew() {
    this.openLogin = false;
    this.openForgotPass = true;
    this.openToken = false;
    this.openNewPass = false;
  }
  openTokenView() {
    this.openLogin = false;
    this.openForgotPass = false;
    this.openToken = true;
    this.openNewPass = false;
  }
  openNewPassView() {
    if (this.esqueciSenha.token.length < 6) {
      return this.toasty.error("Digite um código válido!");
    } else {
      this.openLogin = false;
      this.openForgotPass = false;
      this.openToken = false;
      this.openNewPass = true;
    }
  }


  novaSolicitacao() {
    if (this.reCaptcha != null) {

      this.atualizarLoadingLogin(true);
      this.solicitarAlteracao(this.esqueciSenha)
        .then(() => {
          this.atualizarLoadingLogin(false);

          // A tela dizia "E-mail não encontrado!" quando o corpo da resposta vinha vazio —
          // e com isso respondia, a qualquer visitante, se um e-mail tem conta no sistema.
          // A resposta agora é a mesma nos dois casos, e a mensagem também.
          this.openTokenView();
          this.toasty.success(
            "Se este e-mail estiver cadastrado, o código de verificação chegará na caixa de entrada."
          );

          this.router.navigate(["/login"]);
        })
        .catch(erro => {
          this.errorHandler.handle(erro);
        });
    } else {
      this.errorHandler.handle("É necessário a confirmação do CAPCTHA.");
    }
  }

  confirmarAlteracao() {
    if (this.reCaptcha != null) {
      if (this.esqueciSenha.senha == this.confirmeSenha) {
        this.salvarNovaSenha(this.esqueciSenha)
          .then(() => {
            this.toasty.success("Alteração confirmada com sucesso!");
            this.openLoginView();
          })
          .catch(erro => this.errorHandler.handle(erro));
      } else {
        this.toasty.error("As senhas digitadas não conferem.");
      }
    } else {
      this.errorHandler.handle("É necessário a confirmação do CAPCTHA.");
    }
  }

  /**
   * Pede o código para redefinir a senha.
   *
   * Ia para o microsserviço de e-mail (`send-mail/token`), que buscava o código em
   * `/usuarios/solicitacao` — uma rota pública que o devolvia no corpo da resposta. Agora vai
   * direto para a API, que gera o código e o envia ela mesma: ele não passa mais por aqui.
   *
   * Só o e-mail é enviado. A senha ia junto no corpo, para um serviço externo, sem precisar.
   */
  solicitarAlteracao(esqueciSenha: EsqueciSenha): Promise<any> {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this.http
      .post(`${this.usuarioUrl}/solicitacao?finalidade=RECUPERACAO`,
        JSON.stringify({ email: esqueciSenha.email }), { headers })
      .toPromise()
      .then(response => {
        return response;
      });
  }

  /**
   * Pede o código do segundo fator, na entrada.
   *
   * Mesma mudança de `solicitarAlteracao`, e o mesmo motivo — inclusive quanto à senha, que
   * neste fluxo era postada em claro para o serviço externo a cada tentativa de login.
   */
  solicitarLogin(esqueciSenha: EsqueciSenha): Promise<any> {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this.http
      .post(`${this.usuarioUrl}/solicitacao?finalidade=ACESSO`,
        JSON.stringify({ email: esqueciSenha.email }), { headers })
      .toPromise()
      .then(response => {
        return response;
      });
  }

  salvarNovaSenha(esqueciSenha: EsqueciSenha): Promise<EsqueciSenha> {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this.http
      .post(`${this.usuarioUrl}/alteracao`, JSON.stringify(esqueciSenha), {
        headers
      })
      .toPromise()
      .then(response => response.json());
  }

  validarCodigoVerificacao(usuario: EsqueciSenha): Promise<boolean> {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this.http
      .post(`${this.usuarioUrl}/validar-login`, JSON.stringify(usuario), {
        headers
      })
      .toPromise()
      .then(response => response.json() as boolean);
  }

  
  validarDoisFatores(usuario: EsqueciSenha): Promise<DoisFatoresResponse> {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this.http
      .post(`${this.usuarioUrl}/validar-dois-fatores`, JSON.stringify(usuario), {
        headers
      })
      .toPromise()
      .then(response => response.json() as DoisFatoresResponse);
  }


}